<template>
<div>
    <table>
    <pt-form-list-item label="拒绝理由:">
        <wt-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="rejectedReason"></wt-input>
    </pt-form-list-item>
    </table>
    <div class="button-div">
        <el-button type="primary" @click="rejectReview" :loading="loading">驳回</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
export default {
  props: {
    couponDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      rejectedReason: '',
      loading: false
    }
  },
  methods: {
    rejectReview () {
      let data = {
        status: 'REJECTION',
        id: this.couponDetail.id,
        rejectedReason: this.rejectedReason
      }
      this.loading = true
      this.$store.dispatch('couponUpdateStatus', data).then(res => {
        this.loading = false
        this.$message.success('驳回优惠劵成功')
        this.$emit('close', true)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '驳回优惠劵失败')
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>
<style module lang="less">
</style>
